import { Controller, useFormContext } from 'react-hook-form';
import { User01 } from '@untitledui/icons';
import { Input } from '@/components/base/input/input';
import { AUTH_FORM_SIZE } from '@/shared/config/auth-form';
import type { SignupFormValues } from '../schema';

export const Step01Nome = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext<SignupFormValues>();

  return (
    <Controller
      control={control}
      name="nome"
      render={({ field }) => (
        <Input
          label="Nome completo"
          type="text"
          size={AUTH_FORM_SIZE}
          icon={User01}
          placeholder="Como devemos te chamar"
          autoComplete="name"
          autoFocus
          isInvalid={!!errors.nome}
          hint={errors.nome?.message}
          value={field.value ?? ''}
          onChange={field.onChange}
          onBlur={field.onBlur}
          name={field.name}
        />
      )}
    />
  );
};
